import MyTable from "components/UIElements/MyTable";

export default function DeviceTrips({ endPoint }) {

    const columns = [
        {
            title: 'ΙΜΕΙ Συσκευής',
            key: 'imei',
            dataIndex: 'imei',
        },
        {
            title: 'IMSI',
            dataIndex: 'imsi',
            key: 'imsi',
        },
        {
            title: 'Αρ. Συμβολαίου',
            dataIndex: 'policyNumber',
            key: 'policyNumber',
        },
        {
            title: 'Κατάσταση Συσκευής',
            key: 'deviceStatus',
            dataIndex: 'deviceStatus',
        },
        {
            title: 'Ημ/νία Ενημέρωσης Κατάστασης Συσκευής',
            key: 'deviceStatusDate',
            dataIndex: 'deviceStatusDate',
        },
        {
            title: 'Ημ/νία Τελευταίας Σύνδεσης',
            key: 'lastSeen',
            dataIndex: 'lastSeen'
        },
        {
            title: 'Ημ/νία Έναρξης Διαδρομής',
            key: 'startDate',
            dataIndex: 'startDate'
        },
        {
            title: 'Ημ/νία Κλείσιμου Διαδρομής',
            key: 'endDate',
            dataIndex: 'endDate',
        },
        {
            title: 'Συνολ. Χιλιομ. Διαδρομής',
            key: 'kilometers',
            dataIndex: 'kilometers'
        },
        {
            title: 'Ημ/νία Alarm Plugin',
            key: 'latestAlarmPluginDate',
            dataIndex: 'latestAlarmPluginDate'
        },
        {
            title: 'Ημ/νία Alarm Plugout',
            key: 'latestAlarmPlugoutDate',
            dataIndex: 'latestAlarmPlugoutDate'
        },
    ];

    return <MyTable columns={columns} endPoint={endPoint} />

}